import { FC } from 'react';
import { RoundDocumentsSectionView } from './RoundDocumentsSection';
import { PREVIEW_ROUND_DOCUMENTS } from './roundDocuments.fixtures';

/** Sample-data stand-in for the Documents card while it is frosted. */
export const RoundDocumentsPreview: FC = () => (
  <RoundDocumentsSectionView roundId={-1} documents={PREVIEW_ROUND_DOCUMENTS} canEdit={false} />
);
